// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2YNhO","board":"home_board__1OoNM","player_container":"home_player_container__1eexV"};